'use client';

import { store } from '@store';
import { setEmployee } from '@store/slices/employeeSlice';
import { useEffect } from 'react';
import { IApiEmployee } from 'sales-types-common';

export interface IEmployeeProviderProps {
  employee: IApiEmployee;
  children: React.ReactNode;
}

export const EmployeeProvider = ({ employee, children }: IEmployeeProviderProps) => {
  useEffect(() => {
    if (employee) {
      store.dispatch(setEmployee(employee));
    }
  }, [employee]);

  if (!employee) {
    return;
  }

  return <>{children}</>;
};
